module.exports = __webpack_public_path__ + "static/helsingo-16ef4bc7fd5a36308f4b4a5edf9c6537.png";